import React, { useState } from "react";
import styled from "styled-components";
import { rem } from "polished";

import { ReactComponent as MinusIcon } from "../../assets/img/icon-minus.svg";
import { ReactComponent as PlusIcon } from "../../assets/img/icon-plus.svg";

const El = styled.div`
	width: ${rem(165)};
	margin-top: ${rem(10)};
	margin-bottom: ${rem(10)};
	position: relative;
	border: 1px solid #aeb1b7;
	border-radius: 4px;
	height: ${rem(32)};
	display: flex;
	justify-content: space-between;
	font-family: sans-serif;
`;

const StyledButton = styled.button`
	appearance: none;
	background: linear-gradient(180deg, #f5f6f8 0%, #eeeff1 100%);
	border: 0;
	height: 100%;
	width: ${rem(40)};
	padding: 0;
	cursor: pointer;
	position: relative;
	transition: opacity 0.3s;

	&[disabled] {
		opacity: 0.2;
		cursor: auto;
	}

	svg {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	&:focus {
		outline: none;
	}

	&:nth-of-type(1) {
		border-right: 1px solid #aeb1b7;
		border-radius: 4px 0 0 4px;
	}

	&:nth-of-type(2) {
		border-left: 1px solid #aeb1b7;
		border-radius: 0 4px 4px 0;
	}
`;

const Amount = styled.span`
	font-size: ${rem(13)};
	line-height: ${rem(32)};
`;

const NumbersSelect = ({ maxQuantity, onChange, checkboxActive }) => {
	const [value, setValue] = useState(1);

	const adjustValue = (val, e) => {
		let targetAmount = value + val;

		targetAmount >= 1 && targetAmount <= maxQuantity && setValue(targetAmount);

		onChange(targetAmount, e);
	};

	return (
		<El>
			<StyledButton
				onClick={(e) => {
					// e.stopPropagation();
					adjustValue(-1, e);
				}}
				disabled={value === 1 || !checkboxActive}
				data-numbers="minus"
			>
				<MinusIcon data-numbers="minus" />
			</StyledButton>

			<Amount>{value}</Amount>

			<StyledButton
				onClick={(e) => {
					// e.stopPropagation();
					adjustValue(1, e);
				}}
				disabled={value === maxQuantity || !checkboxActive}
				data-numbers="plus"
			>
				<PlusIcon data-numbers="plus" />
			</StyledButton>
		</El>
	);
};

export default NumbersSelect;
